/* eslint-disable arrow-parens */

import { ACTIONS, WORD_STATUS, GAME_ID } from '../dataManagement/Constants';

export const initialState = {
  draggables: [],
  positionMarkers: [],
  showingDescriptions: false,
  isOnBoarding: false,
};

export const positionMarker = (state, action) => {
  const { payload } = action;
  switch (action.type) {
    case ACTIONS.UPDATE_MARKER_POSITION:
      if (payload.id === state.id) {
        return {
          ...state,
          position: payload.position,
        };
      }
      return state;

    default:
      return state;
  }
};

export const draggable = (state, action) => {
  const { payload } = action;
  switch (action.type) {
    case ACTIONS.SET_ALL_PANEL_TO_CORRECT:
      return {
        ...state,
        status: WORD_STATUS.CORRECT,
        withDescription: false,
      };

    case ACTIONS.SET_AS_INCORRECT:
      if (payload.id === state.id) {
        return {
          ...state,
          status: WORD_STATUS.INCORRECT,
        };
      }
      return state;

    case ACTIONS.RESET_DRAGGABLE_STATUS:
      if (payload.id === state.id) {
        return {
          ...state,
          status: WORD_STATUS.UNSELECTED,
          withDescription: false,
        };
      }
      return state;

    case ACTIONS.SHOW_DESCRIPTION_OF_TARGET_WORD_ID:
      return {
        ...state,
        status: WORD_STATUS.UNSELECTED,
        withDescription: payload.id === state.id,
      };

    case ACTIONS.SHOW_DESCRIPTIONS_FOR_ALL_INCORRECT_WORDS:
      if (state.status === WORD_STATUS.INCORRECT) {
        return {
          ...state,
          withDescription: true,
          withIncorrectStyle: true,
        };
      }
      return state;

    case ACTIONS.SELECT_DRAGGABLE:
      if (payload.id === state.id) {
        return {
          ...state,
          status: WORD_STATUS.SELECTED,
          canSnap: false,
        };
      }
      return {
        ...state,
        status: WORD_STATUS.AVAILABLE,
      };

    case ACTIONS.RELEASE_DRAGGABLE:
      if (payload.id === state.id) {
        return {
          ...state,
          status: WORD_STATUS.UNSELECTED,
          isReturning: false,
          canSnap: true,
        };
      }
      return {
        ...state,
        status: WORD_STATUS.UNSELECTED,
      };

    case ACTIONS.UPDATE_DRAGGABLE_POSITION:
      if (payload.id === state.id) {
        return {
          ...state,
          position: payload.position,
        };
      }
      return state;

    case ACTIONS.INIT_DRAGGABLE_POSITION:
      if (payload.id === state.id) {
        return {
          ...state,
          position: payload.position,
        };
      }
      return state;

    default:
      return state;
  }
};

const makeSortedArrayByPosition = array =>
  Array.from(array).sort((a, b) => {
    if (a.position < b.position) {
      return -1;
    }
    return 1;
  });

const updateDraggablesOrder = draggables => {
  const sorted = makeSortedArrayByPosition(draggables);
  const updatedDraggables = Array.from(draggables);
  for (let i = 0; i < draggables.length; i++) {
    updatedDraggables[sorted[i].id].order = i;
  }
  return updatedDraggables;
};

const standardViewData = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  const { payload } = action;
  switch (action.type) {
    case ACTIONS.INIT_SHADES_SESSION:
      return initialState;

    case ACTIONS.CREATE_WORD_PANEL_DATA:
      return {
        ...initialState,
        positionMarkers: payload.positionMarkers,
        draggables: payload.draggables,
      };

    case ACTIONS.SHOW_DESCRIPTIONS_FOR_ALL_INCORRECT_WORDS:
      return {
        ...state,
        draggables: state.draggables.map(d => reducers.draggable(d, action)),
        showingDescriptions: true,
      };

    case ACTIONS.AUTO_COMPLETE_THIS_SET:
      return {
        ...state,
        isOnBoarding: true,
      };

    case ACTIONS.UPDATE_DRAGGABLE_POSITION:
      return {
        ...state,
        draggables: helperFunctions.updateDraggablesOrder(state.draggables.map(d => reducers.draggable(d, action))),
      };

    default:
      return {
        ...state,
        positionMarkers: state.positionMarkers.map(p => reducers.positionMarker(p, action)),
        draggables: state.draggables.map(d => draggable(d, action)),
      };
  }
};

const reducers = {
  draggable,
  positionMarker,
};

const helperFunctions = {
  updateDraggablesOrder,
  makeSortedArrayByPosition,
};

export { reducers as _reducers };
export { helperFunctions as _helperFunction };
export default standardViewData;
